const findTopicAndSubtopic = (availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[], mergefield: string): { topic: server.dto.AvailableMergeFieldTopic, subtopic: server.dto.AvailableMergeFieldSubTopic, label: string } => {
  for (const topic of availableMergeFieldTopics) {
    for (const subtopic of topic.subTopics) {
      for (const mf of subtopic.mergeFields) {
        if (mf.mergeField === mergefield) {
          return {
            topic,
            subtopic,
            label: mf.label
          };
        }
      }
    }
  }

  return undefined;
};

export const createMergefieldPath = (availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[], mergefield: string): string => {
  const result = findTopicAndSubtopic(availableMergeFieldTopics, mergefield);
  if (!result) {
    return "";
  }

  const { topic, subtopic, label } = result;
  return `${topic.label} > ${subtopic.label} > ${label}`;
}

export const containsAnyMergefields = (topic: server.dto.AvailableMergeFieldTopic) => topic.subTopics.some(subTopic => subTopic.mergeFields.length > 0);

export const getSelectionCountByTopic = (availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[], selectedMergeFieldsSet: Set<string>) => {
  return availableMergeFieldTopics.map(topic => {
    let count = 0;
    topic.subTopics.forEach(subTopic => {
      subTopic.mergeFields.forEach(mf => {
        if (selectedMergeFieldsSet.has(mf.mergeField)) {
          count++;
        }
      });
    });

    return {
      topicLabel: topic.label,
      count
    };
  }).reduce((acc, curr) => {
    acc[curr.topicLabel] = curr.count;
    return acc;
  }, {} as Record<string, number>);
}

export const getFilteredMergetopics = (availableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[], searchQuery: string) => {
  if (searchQuery.trim() === "") {
    return availableMergeFieldTopics;
  }

  const res = availableMergeFieldTopics
    .map(topic => ({
      ...topic,
      subTopics: topic.subTopics.map(subtopic => ({
        ...subtopic,
        mergeFields: subtopic.mergeFields.filter(mf => (
          (mf.label.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())) ||
          (mf.mergeField.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())) ||
          (subtopic.label.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())) ||
          (topic.label.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase()))
        ))
      }))
    }));

  return res;
};